export default __webpack_public_path__ + "static/media/Screenshot_B8.80e3268b.jpg";